export default __webpack_public_path__ + "static/media/eb-pro-wht-1.f51aa7b5.png";